import styles from './stageUI.module.scss';

// A persistent banner shown at the top of a stage form when the user tries
// to advance with missing required fields. Unlike a toast, it stays on the
// page and names exactly what needs attention.
const ErrorSummary = ({fields = []}) => {
  if (!fields.length) return null;
  const count = fields.length;
  return (
    <div
      className={`${styles['error-summary']} stage-error-summary`}
      role="alert">
      <span className={styles['error-summary-title']}>
        {count} field{count > 1 ? 's need' : ' needs'} attention before you can
        continue
      </span>
      <ul className={styles['error-summary-list']}>
        {fields.map(field => (
          <li key={field}>{field}</li>
        ))}
      </ul>
    </div>
  );
};

export default ErrorSummary;
